var _defineProperty = require("/home/runner/work/unitpedia/unitpedia/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * In the recognition result of tesseract, there
 * is a deep JSON object for details, it has around
 *
 * The result of dump.js is a big JSON tree
 * which can be easily serialized (for instance
 * to be sent from a webworker to the main app
 * or through Node's IPC), but we want
 * a (circular) DOM-like interface for walking
 * through the data.
 *
 * @fileoverview DOM-like interface for walking through data
 * @author Kevin Kwok <antimatter15@gmail.com>
 * @author Guillermo Webster <gui@mit.edu>
 * @author Jerome Wu <jeromewus@gmail.com>
 */
module.exports = function (page) {
  var blocks = [];
  var paragraphs = [];
  var lines = [];
  var words = [];
  var symbols = [];
  page.blocks.forEach(function (block) {
    block.paragraphs.forEach(function (paragraph) {
      paragraph.lines.forEach(function (line) {
        line.words.forEach(function (word) {
          word.symbols.forEach(function (sym) {
            symbols.push(_objectSpread(_objectSpread({}, sym), {}, {
              page: page,
              block: block,
              paragraph: paragraph,
              line: line,
              word: word
            }));
          });
          words.push(_objectSpread(_objectSpread({}, word), {}, {
            page: page,
            block: block,
            paragraph: paragraph,
            line: line
          }));
        });
        lines.push(_objectSpread(_objectSpread({}, line), {}, {
          page: page,
          block: block,
          paragraph: paragraph
        }));
      });
      paragraphs.push(_objectSpread(_objectSpread({}, paragraph), {}, {
        page: page,
        block: block
      }));
    });
    blocks.push(_objectSpread(_objectSpread({}, block), {}, {
      page: page
    }));
  });
  return _objectSpread(_objectSpread({}, page), {}, {
    blocks: blocks,
    paragraphs: paragraphs,
    lines: lines,
    words: words,
    symbols: symbols
  });
};